(function () {
  const observer = new MutationObserver(() => {
    document.querySelectorAll('.m-sub-nav a.m-nav[href*="/products/"]').forEach(link => {
      if (link.querySelector('.meteor-menu-desc')) return;

      const handle = link.getAttribute('href')
        .replace('/products/', '')
        .split('?')[0];

      fetch('/products/' + handle + '.js')
        .then(res => res.json())
        .then(product => {
          const desc = document.createElement('div');
          desc.className = 'meteor-menu-desc';
          desc.textContent = product.description
            .replace(/(<([^>]+)>)/gi, '')
            .trim()
            .slice(0, 80);

          link.appendChild(desc);
        })
        .catch(() => {});
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();

(function () {
  const map = { 'high-mixed-pack-lp': 'mixed-pack' };
  const fix = () => {
    document.querySelectorAll('[class*="jdgm"] a[href*="-lp"]').forEach(link => {
      const url = new URL(link.href, location.origin);
      const match = url.pathname.match(/\/products\/([^/]+)-lp$/);
      if (!match) return;
      const handle = match[1] + '-lp';
      url.pathname = '/products/' + (map[handle] || match[1]);
      link.href = url.pathname + url.search;
    });
  };
  fix();
  new MutationObserver(fix).observe(document.body, { childList: true, subtree: true });
})();
